/* eslint-disable jsx-a11y/control-has-associated-label */
import React from "react";
import EventSummary from "./EventSummary";
import Errors from "../../../Components/Errors";

export default function WorkflowSummary({ state, node, engine }) {
  if (state.EventListeners?.length) {
    return [
      "runtime:start",
      "runtime:end",
      "message:reply",
      "outbound-delivery-status",
      "milestone",
      "form-render",
      "form-submitted",
      "form-accessed",
      "component:package",
    ]
      .filter((item) =>
        state.EventListeners?.some((listener) => listener.EventType === item)
      )
      .map((event) => (
        <EventSummary
          key={event}
          state={state}
          event={event}
          node={node}
          engine={engine}
        />
      ));
  }
  return <Errors filterFn={(e) => e.workflow?.UUID === state.UUID} />;
}
